import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { getConfigSelector } from 'state';
import { getEntidadeByPathname, isAuthenticated } from 'utils';

const TelaPadraoAberturaUrls = {
  CONSULTA_PROCESSO_CHAVE: '/consulta-processo-chave',
  CONSULTA_PROCESSO: '/consultaProcesso',
  ABERTURA_PROCESSO: '/aberturaProcessoExterno',
  OUVIDORIA: '/ouvidoria'
};

export const RedirectContainer = ({ children }) => {
  const history = useHistory();
  const isLogged = isAuthenticated();
  const entidadePathName = getEntidadeByPathname();
  const { telaPadraoAberturaProtocolo } = useSelector(getConfigSelector);

  useEffect(() => {
    let url = TelaPadraoAberturaUrls[telaPadraoAberturaProtocolo];
    if (url && !isLogged && history.location.pathname?.match(/^\/\d*\/?$/)) {
      url = entidadePathName ? `/${entidadePathName}${url}` : url;

      history.push(url);
    }
  }, [telaPadraoAberturaProtocolo]);

  useEffect(() => {
    if (isLogged && window.location.search.includes('login')) {
      window.history.replaceState(null, null, window.location.pathname);
      history.push('/');
    }
  }, []);

  return <>{children}</>;
};
